import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { enviroment } from 'src/environments/environment';
import { catchError, Observable, of, tap } from 'rxjs';
import { GetAllPublicProjectsResponse, PaginationPublicProjects, PublicProjectResponse, PublicProjectsFeedResponse, ToggleFavoriteProject  } from './public-project-response';


@Injectable({providedIn: 'root'})
export class PublicService {
  publicUrl: string;
  httpOptions: {};
  favoriteProjectUrl: string;

  constructor(private http: HttpClient) {
    this.publicUrl = enviroment.BASE_URL_API + '/global';
    this.favoriteProjectUrl = enviroment.BASE_URL_API + '/user';
    this.httpOptions = {};

  }



  getPublicProject(user: string, project: string): Observable<PublicProjectResponse> {
    const url = `${this.publicUrl}/user/${user}/project/${project}`;
    return this.http.get<PublicProjectResponse>(url).pipe(
      tap(),
      catchError(this.handleError<PublicProjectResponse>(`findPublicProject`))
    );
  }

  getAllPublicProjects(sharingProjectTypeID: number, cursor?: string | null, mostLikedProjects?: number, userID?: string): Observable<PublicProjectsFeedResponse> {
    let params = new HttpParams().set('sharingProjectTypeID', sharingProjectTypeID.toString());
    if (cursor) params = params.set('cursor', cursor);
    if (mostLikedProjects) params = params.set('mostLikedProjects', mostLikedProjects.toString());
    if (userID) params = params.set('userID', userID);
    const url = `${this.publicUrl}/all_public_projects`;
    return this.http.get<PublicProjectsFeedResponse>(url, { params }).pipe(
      tap(),
      catchError(this.handleError<PublicProjectsFeedResponse>(`findtAllPublicProjects`))
    );
  }

  getPublicLinkProject(projectID: string,): Observable<any> {
    const url = `${this.publicUrl}/get_public_link_project?projectID=${projectID}&page=1&pageItens=1`;
    return this.http.get<any>(url).pipe(
      tap(),
      catchError(this.handleError<any>(`findPublicLinkProject`))
    );
  }

  getFavoriteProject(userID: string, page: number, itensPage: number): Observable<PaginationPublicProjects>{
    const url = `${this.favoriteProjectUrl}/${userID}/favorite_projects?page=${page}&pageItens=${itensPage}`;
    return this.http.get<PaginationPublicProjects>(url, this.httpOptions).pipe(
      tap(),
      catchError(this.handleError<PaginationPublicProjects>(`findFavoriteProject`))
    );
  }

  toggleFavoriteProject(projectID: string, userID: string): Observable<ToggleFavoriteProject> {
    const url = `${this.favoriteProjectUrl}/${userID}/favorite/project/${projectID}`;
    return this.http.post<ToggleFavoriteProject>(url, this.httpOptions).pipe(tap(),
      catchError(this.handleError<ToggleFavoriteProject>(`findToggleFavoriteProject`))
    );
  }

  getSelectedFavoriteProjectList(userID: string): Observable<ToggleFavoriteProject>{
    const url = `${this.favoriteProjectUrl}/${userID}/selected_favorite_project_list`;
    return this.http.get<ToggleFavoriteProject>(url).pipe(tap(),
      catchError(this.handleError<ToggleFavoriteProject>(`findSelectedFavoriteProjectList`))
    );
  }

  getCountry() {
        return this.http.get('https://get.geojs.io/v1/ip/geo.json'); // API de geolocalização
    }
  

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
